import createIcon from '../../createIcon';

/**
 * @component @name BorderHorizontal
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAyMUg1VjE5SDNWMjFaTTUgN0gzVjlINVY3Wk0zIDE3SDVWMTVIM1YxN1pNNyAyMUg5VjE5SDdWMjFaTTUgM0gzVjVINVYzWk05IDNIN1Y1SDlWM1pNMTcgM0gxNVY1SDE3VjNaTTEzIDdIMTFWOUgxM1Y3Wk0xMyAzSDExVjVIMTNWM1pNMTkgMTdIMjFWMTVIMTlWMTdaTTExIDIxSDEzVjE5SDExVjIxWk0zIDEzSDIxVjExSDNWMTNaTTE5IDNWNUgyMVYzSDE5Wk0xOSA5SDIxVjdIMTlWOVpNMTEgMTdIMTNWMTVIMTFWMTdaTTE1IDIxSDE3VjE5SDE1VjIxWk0xOSAyMUgyMVYxOUgxOVYyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderHorizontal = createIcon('BorderHorizontal', [
  [
    'path',
    {
      d: 'M3 21H5V19H3V21ZM5 7H3V9H5V7ZM3 17H5V15H3V17ZM7 21H9V19H7V21ZM5 3H3V5H5V3ZM9 3H7V5H9V3ZM17 3H15V5H17V3ZM13 7H11V9H13V7ZM13 3H11V5H13V3ZM19 17H21V15H19V17ZM11 21H13V19H11V21ZM3 13H21V11H3V13ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM11 17H13V15H11V17ZM15 21H17V19H15V21ZM19 21H21V19H19V21Z',
      key: 'jutlki',
    },
  ],
]);

export default BorderHorizontal;
